/**
 * Plugin responsável por centralizar e exibir informações de log
 */
export default {
  install(Vue) {
    const plugin = {
      debug(message, ...params) {
        // eslint-disable-next-line
        console.info(message, params);
      },
      error(message, ...params) {
        // eslint-disable-next-line
        console.error(message, params);
      },
    };

    Vue.$log = plugin;
    Vue.prototype.$log = plugin;
  },
};



// WEBPACK FOOTER //
// ./src/plugins/LogPlugin.js